import { Api, API_ORIGIN } from './index';

export const submitMediaExport = async (formData) => {
  const response = await fetch(`${API_ORIGIN}/v1/media/export`, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Server error: ${response.status}`);
  }

  return data;
};

export const getExportStatus = async (jobId) => {
  const response = await Api.get(`media/exports/${jobId}`);
  return response.data;
};

export const retryExport = async (jobId) => {
  const response = await Api.post(`media/exports/${jobId}/retry`);
  return response.data;
};
